import React, { useCallback, useState } from 'react';

import { Menu } from '@mui/material';
import { FilePlus, Sparkles } from 'lucide-react';
import { OptionsMenuItem, PrimaryPlusIconButton } from 'src/components';

import { useCreateSkillAndEdit } from './use-create-skill-and-edit';
import { useCreateSkillWithAi } from './use-create-skill-with-ai';

/** The skills list's "+": a blank skill, or a new chat that drafts one with the agent. */
export const NewSkillButton = React.memo(function NewSkillButton(): JSX.Element {
  const [open, setOpen] = useState(false);
  const { createSkillWithAi } = useCreateSkillWithAi();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const { createSkillAndEdit, loading } = useCreateSkillAndEdit();
  const toggle = useCallback(() => setOpen(current => !current), []);
  const close = useCallback(() => setOpen(false), []);
  const createWithAi = useCallback(() => {
    setOpen(false);
    createSkillWithAi();
  }, [createSkillWithAi]);
  const createBlank = useCallback(() => {
    setOpen(false);
    void createSkillAndEdit();
  }, [createSkillAndEdit]);

  return (
    <>
      <PrimaryPlusIconButton
        ref={setAnchorEl}
        data-cy="admin-skills-new-button"
        disabled={loading}
        tooltip="New skill"
        onClick={toggle}
      />
      <Menu
        keepMounted
        anchorEl={anchorEl}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        open={open}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        variant="menu"
        onClose={close}
      >
        <OptionsMenuItem
          clickHandler={createBlank}
          icon={<FilePlus size={16} />}
          text="Create blank skill"
        />
        <OptionsMenuItem
          clickHandler={createWithAi}
          icon={<Sparkles size={16} />}
          text="Create skill with AI"
        />
      </Menu>
    </>
  );
});
